import { FC, useState } from 'react';
import { withStyles, Card, TextField } from 'vopay';
import styles from './AddLabelDialog.module.scss';
import { Title, Button } from 'UI';
import { renderDefaultFormElement } from '@/components/Form/utils';
import { useTranslation } from 'react-i18next';

const cn = withStyles(styles);

type AddLabelDialogProps = {
  onClose: () => void;
  onAdd: (label: string) => void;
};

const AddLabelDialog: FC<AddLabelDialogProps> = ({ onClose, onAdd }) => {
  const [label, setLabel] = useState('');
  const { t } = useTranslation('translations', { keyPrefix: 'Customers.Create.LabelDialog' });

  async function handleAddLabel() {
    onAdd(label);
  }

  return (
    <Card className={cn('addLabelDialog')}>
      <Title level="3" className={cn('title')}>
        {t('addNewLabel')}
      </Title>

      {renderDefaultFormElement({
        fieldName: 'label',
        label: t('labelName'),
        inputState: 'required',
        tooltip: null,
        template: (
          <TextField
            name="label"
            variant="outlineShadow"
            placeholder={t('labelName')}
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
        ),
      })}

      <div className={cn('ctas')}>
        <Button onClick={onClose}>{t('back')}</Button>

        <Button disabled={!label} colorScheme="primary" onClick={handleAddLabel}>
          {t('addLabel')}
        </Button>
      </div>
    </Card>
  );
};

export default AddLabelDialog;
